import { createFileRoute } from "@tanstack/react-router";
import AdminSupportAgent from "@/pages/admin/AdminSupportAgent";

export const Route = createFileRoute("/admin/support-agent")({ component: AdminSupportAgent });
